import { Col, Collapse, Row, message } from "antd";
import React, { useEffect, useState } from "react";
import NonProtectedLayout from "../../components/layout/NonProtectedLayout";
import API_MANAGER from "../../API";
import { IsTokenValid } from "../../utils/middleware";
import Layout from "../../components/layout";
import SubLayout from "../../components/layout/SubLayout";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import { useLocation } from "react-router-dom";
import moment from "moment";
import MobileHeader from "../../components/layout/MobileHeader";
function PrivacyPolicy() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const isAuthenticated = IsTokenValid();
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    API_MANAGER.getPrivacyPolicyData()
      .then((res) => {
        setLoading(false);
        setData(res?.data?.data);
      })
      .catch((err) => {
        setLoading(false);
        message.error("Something went wrong. Please try again.");
      });
  }, []);
  const name = localStorage.getItem("name");
  const createdAt = localStorage.getItem("createdAt");
  return (
    <>
      {isAuthenticated ? (
        <Layout>
          <SubLayout page={"Privacy Policy"}>
            <div className="terms_of_use_container">
              <MobileHeader title={"Privacy Policy"} />
              <div className="aboutus_banner">
                <h2 className="bannerHeading">Privacy Policy</h2>
              </div>
              <div className="dynamic_content_container">
                <div className="mb-45">
                  <p className="terms_heading">"Cinchy.me" Privacy Policy</p>

                  <span className="acceptanceText">
                    Accepted by{" "}
                    <span
                      className="acceptanceText"
                      style={{ textTransform: "capitalize" }}
                    >
                      {name ? name : ""}
                    </span>{" "}
                    on {moment(createdAt).format("DD/MM/YYYY")}
                  </span>
                </div>
                <div
                  className="apiData"
                  dangerouslySetInnerHTML={{ __html: data?.description }}
                />
              </div>
            </div>
          </SubLayout>
        </Layout>
      ) : (
        <NonProtectedLayout back={location.search ? true : null}>
          <div className="terms_of_use_container">
            <FullScreenLoader isLoading={loading} />
            <Row>
              <Col xs={24} md={0}>
                <p className="goback">{"< Privacy Policy"}</p>
              </Col>
            </Row>
            <Row>
              <div style={{ marginTop: "20px" }} className="aboutus_banner">
                <h2 className="bannerHeading">Privacy Policy</h2>
              </div>
            </Row>
            <div className="dynamic_content_container">
              <p className="terms_heading mt-8">
                At "Cinchy.me", your privacy is important to us.
              </p>
              <div
                className="apiData"
                dangerouslySetInnerHTML={{ __html: data?.description }}
              />
            </div>
          </div>
        </NonProtectedLayout>
      )}
    </>
  );
}

export default PrivacyPolicy;
